import React from "react";
import { useLang } from "@/i18n/LanguageContext";
import CertBadges from "@/components/CertBadges";
import { BadgeCheck, Users, Building2, ShieldCheck } from "lucide-react";

export default function WhyUsSection() {
  const { t } = useLang();
  const features = [
    { key: "f1", i: BadgeCheck },
    { key: "f2", i: Users },
    { key: "f3", i: Building2 },
    { key: "f4", i: ShieldCheck },
  ];
  return (
    <section className="py-24 lg:py-32 bg-card border-y border-border" data-testid="why-section">
      <div className="container-x">
        <div className="mb-14 flex flex-col lg:flex-row lg:items-end lg:justify-between gap-8">
          <div className="max-w-2xl">
            <div className="flex items-center gap-4 mb-4">
              <span className="h-px w-10 bg-accent" />
              <p className="overline">{t("sections.whyOver")}</p>
            </div>
            <h2 className="font-serif text-4xl lg:text-5xl text-primary tracking-tight">{t("sections.whyTitle")}</h2>
          </div>
          <div className="shrink-0">
            <p className="overline mb-3">Tersertifikasi Resmi</p>
            <CertBadges size="h-14" />
          </div>
        </div>
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-px bg-border rounded-lg overflow-hidden">
          {features.map((f) => (
            <div key={f.key} className="bg-card p-10 hover:bg-muted/40 transition-colors" data-testid={`why-card-${f.key}`}>
              <f.i className="h-7 w-7 text-accent" strokeWidth={1.5} />
              <h3 className="font-serif text-xl text-primary mt-5">{t(`why.${f.key}`)}</h3>
              <p className="text-muted-foreground text-sm mt-3 leading-relaxed">{t(`why.${f.key}d`)}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
